import { useEffect, useState } from "react";
import axios from "axios";
import {
  FiEdit2,
  FiTrash2,
  FiPlus,
  FiMinus,
  FiSave,
  FiX
} from "react-icons/fi";
import BASE_URL from "../../constante";
import ConfirmModal from "../../components/ConfirmModal";
import { toast } from "react-toastify";
const statusOptions =["en attente", "livré", "annulé"];
const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
const [showDetails, setShowDetails] = useState(false);
const [isEditing, setIsEditing] = useState(false);
const [editedItems, setEditedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmMode, setConfirmMode] = useState(null); 
  const [targetOrderId, setTargetOrderId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const ordersPerPage = 10; 

  const totalPages = Math.ceil(orders.length / ordersPerPage);

  // Slice orders for current page
  const paginatedOrders = orders.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage
  );
  
  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get(`${BASE_URL}/api/orders`, { withCredentials: true });
      setOrders(data);
    } catch (err) {
      setError("Erreur lors du chargement des commandes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await axios.put(
        `${BASE_URL}/api/orders/${orderId}/status`,
        { status: newStatus },
        { withCredentials: true }
      );
      setOrders(prev => prev.map(o => (o._id === orderId ? { ...o, status: newStatus } : o)));
    } catch (err) {
      toast.error("Impossible de mettre à jour le statut");
    }
  };

  const handleDeleteOrder = (orderId) => {
    setConfirmMode('single');
    setTargetOrderId(orderId);
    setConfirmOpen(true);
  };

  const handleDeleteAllOrders = () => {
    setConfirmMode('all');
    setTargetOrderId(null);
    setConfirmOpen(true);
  };

  const performConfirm = async () => {
    try {
      setConfirmLoading(true);
      if (confirmMode === 'single' && targetOrderId) {
        await axios.delete(`${BASE_URL}/api/orders/${targetOrderId}`, { withCredentials: true });
        setOrders(prev => prev.filter(o => o._id !== targetOrderId));
      } else if (confirmMode === 'all') {
        await axios.delete(`${BASE_URL}/api/orders`, { withCredentials: true });
        setOrders([]);
      }
      setConfirmOpen(false);
      setConfirmMode(null);
      setTargetOrderId(null);
    } catch (err) {
      setError("Opération de suppression échouée");
    } finally {
      setConfirmLoading(false);
    }
  };
const updateQuantity = (index, change) => {
  setEditedItems(prev =>
    prev.map((item, i) => {
      if (i === index) {
        const newQuantity = item.quantity + change;

        return {
          ...item,
          quantity: newQuantity < 1 ? 1 : newQuantity
        };
      }

      return item;
    })
  );
};


const removeItem = (index) => {
  setEditedItems(prev =>
    prev.filter((_, i) => i !== index)
  );
};


const editedTotal = editedItems.reduce(
  (total, item) =>
    total + item.price * item.quantity,
  0
);
const handleSaveOrder = async () => {
  try {
    

    const { data } = await axios.put(
      `${BASE_URL}/api/orders/${selectedOrder._id}`,
      {
        items: editedItems
      },
      {
        withCredentials: true
      }
    );

    // Mettre à jour la commande sélectionnée
    setSelectedOrder(data.order);

    // Mettre à jour la liste des commandes
    setOrders(prev =>
      prev.map(order =>
        order._id === data.order._id
          ? data.order
          : order
      )
    );

    setEditedItems(data.order.items);

    setIsEditing(false);

    toast.success("Commande modifiée avec succès");

  } catch (error) {
    console.error(error);

    toast.error(
      error.response?.data?.message ||
      "Erreur lors de la modification"
    );

  } 
};
  if (loading) return null;
  if (error) return null;
  return (
    <>
    <div className="container mt-4">
    <div className="card border-0 shadow-sm rounded-4">
    <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
    <div>
        <h5 className="text-dark fw-bold mb-0 d-flex align-items-center gap-2">
            Commandes
            <span className="count-pill">
            {orders.length} {orders.length === 1 ? "commande" : "commandes"}
          </span>

          </h5>
          <small className="text-muted d-none d-md-block">Gérez les commandes et leurs statuts.</small>
        </div>
        <button
          className="btn btn-light btn-sm border text-danger d-flex align-items-center gap-1 px-3"
          onClick={handleDeleteAllOrders}
        >
          <FiTrash2 size={14} />
          Supprimer tout
        </button>
      </div>

      <div className="card-body p-0">
  
          <>
            <div className="table-responsive">
              <table className="table table-hover table-sm align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="ps-4">ID</th>
                    <th>Client</th>
                    <th>Produits</th>
                    

                    <th>Total (TND)</th>
                    <th className="text-center">Statut</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedOrders.map(order => {
                    


                    return (
                      <tr key={order._id}>
                        <td className="ps-4">{order._id.slice(-6)}</td>
                        <td>
                          {order.user ? (
                            <div>
                              <div className="fw-semibold">{order.user.name}</div>
                              <small className="text-muted">{order.user.email}</small>
                            </div>
                          ) : (
                            <span className="text-muted">Utilisateur</span>
                          )}
                        </td>
<td>
  {order.items?.length > 0 ? (
  <ul className="list-unstyled mb-0">

    {order.items.slice(0, 3).map((item, index) => (
      <li key={index} className="small mb-1">
        <span className="fw-semibold">
          {item.name || "Produit"}
        </span>

        <span className="text-muted">
          {" × "}
          {item.quantity}
        </span>
      </li>
    ))}

    {order.items.length > 3 && (
      <li className="small text-primary fw-semibold">
        +{order.items.length - 3} autre(s)
      </li>
    )}

  </ul>
) : (
  <span className="text-muted">—</span>
)}
</td>
                        <td className="fw-semibold">{order.total?.toFixed(2)} TND</td>
                        <td className="text-center">
                          <select
                            className="form-select form-select-sm mx-auto"
                            style={{ width: "140px" }}
                            value={order.status}
                            onChange={(e) => handleStatusChange(order._id, e.target.value)}
                          >
                            {statusOptions.map(opt => (
                              <option key={opt} value={opt}>{opt}</option>
                            ))}
                          </select>
                        </td>
                        <td>{new Date(order.createdAt).toLocaleString()}</td>
                        <td className="text-center">

  <button
    className="btn btn-sm btn-light border me-2"
    onClick={() => {
  setSelectedOrder(order);

  setEditedItems(
    order.items.map(item => ({
      ...item
    }))
  );

  setIsEditing(false);
  setShowDetails(true);
}}
  >
    Détails
  </button>


  <button
    className="btn btn-sm btn-light border text-danger action-btn"
    title="Supprimer"
    onClick={() => handleDeleteOrder(order._id)}
  >
    <FiTrash2 size={16} />
  </button>

</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {orders.length > ordersPerPage && (
              <div className="d-flex justify-content-center align-items-center flex-nowrap gap-1 mt-3 mb-2 overflow-auto">
                <button
                  className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                >
                  Préc
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                  <button
                    key={p}
                    className={`pagination-btn ${currentPage === p ? "active" : ""}`}
                    onClick={() => setCurrentPage(p)}
                  >
                    {p}
                  </button>
                ))}

                <button
                  className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
                  onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                >
                  Suiv
                </button>
              </div>
            )}
          </>
       
      </div>
    </div>
  </div>
      {showDetails && selectedOrder && (
<div 
 className="modal d-block"
 style={{backgroundColor:"rgba(0,0,0,.5)"}}
>
  <div className="modal-dialog modal-lg modal-dialog-centered">

    <div className="modal-content">

      <div className="modal-header">
        <h5 className="modal-title">
          Détails commande #{selectedOrder._id.slice(-6)}
        </h5>

        <button
          className="btn-close"
          onClick={() => setShowDetails(false)}
        ></button>
      </div>


      <div className="modal-body">

        <h6>Produits</h6>

        <table className="table table-bordered align-middle mb-0">

  <thead>
    <tr>
      <th>Produit</th>
      <th>Prix</th>

      {isEditing && <th>Quantité</th>}

      <th>Total</th>

      {isEditing && <th>Action</th>}
    </tr>
  </thead>

  <tbody>
    {(isEditing ? editedItems : selectedOrder.items).map(
      (item, index) => (
        <tr key={index}>

          {/* PRODUIT */}
          <td>
            <span className="fw-semibold">
              {item.name || "Produit"}
            </span>

            {!isEditing && (
              <span className="text-muted">
                {" × "}
                {item.quantity}
              </span>
            )}
          </td>


          {/* PRIX */}
          <td>
            {item.price} TND
          </td>


          {/* QUANTITÉ : seulement en modification */}
          {isEditing && (
            <td>
              <div className="d-flex align-items-center gap-2">

                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => updateQuantity(index, -1)}
                >
                  <FiMinus size={14} />
                </button>

                <span className="fw-bold">
                  {item.quantity}
                </span>

                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => updateQuantity(index, 1)}
                >
                  <FiPlus size={14} />
                </button>

              </div>
            </td>
          )}


          {/* TOTAL */}
          <td>
            {(item.price * item.quantity).toFixed(2)} TND
          </td>


          {/* ACTION : seulement en modification */}
          {isEditing && (
            <td className="text-center">
              <button
                type="button"
                className="btn btn-sm btn-light text-danger border"
                onClick={() => removeItem(index)}
              >
                <FiTrash2 size={16} />
              </button>
            </td>
          )}

        </tr>
      )
    )}
  </tbody>

</table>
      
             
<div className="modal-footer">

  {isEditing ? (
  <div className="d-flex gap-2">

    <button
      type="button"
      className="btn btn-outline-secondary"
     
      onClick={() => {
        setEditedItems(
          selectedOrder.items.map(item => ({ ...item }))
        );
        setIsEditing(false);
      }}
    >
      <FiX className="me-2" size={14} />
      Annuler
    </button>

    <button
      type="button"
      className="btn btn-primary"
      
      onClick={handleSaveOrder}
    >
      <FiSave className="me-2" size={14} />
      Enregistrer
    </button>

  </div>
) : (
          
  <>
      <div className="d-flex gap-2">

  <button
    className="btn btn-sm btn-outline-primary"
    onClick={() => setIsEditing(true)}
  >
    <FiEdit2 className="me-1" size={15} />
    Modifier
  </button>

  <button
    className="btn btn-sm btn-outline-secondary"
    onClick={() => setShowDetails(false)}
  >
    <FiX className="me-1" size={15} />
    Fermer
  </button>

</div>
    </>
  )}

</div>
     

        <hr/>


        <h6>Adresse livraison</h6>

        <p>
          {selectedOrder.shippingAddress.street}<br/>
          {selectedOrder.shippingAddress.postalCode} - {selectedOrder.shippingAddress.city}<br/>
          {selectedOrder.shippingAddress.country}
        </p>


        <h6>Facturation</h6>

        <p>
          Nom : {selectedOrder.billingDetails.name}<br/>
          Email : {selectedOrder.billingDetails.email}<br/>
          Téléphone : {selectedOrder.billingDetails.phone}
        </p>


        <hr/>


        <h5>
          Total :
          <span className="text-danger ms-2">
            {isEditing
  ? editedTotal.toFixed(2)
  : selectedOrder.total
} TND
          </span>
        </h5>


      </div>

    </div>

  </div>
</div>
)}
    <ConfirmModal
  open={confirmOpen}
  title="Confirmer la suppression"
  description="Voulez-vous vraiment supprimer cet élément ?"
  confirmText="Supprimer"
  cancelText="Annuler"
  loading={confirmLoading}
  danger
  onConfirm={performConfirm}
  onCancel={() => {
    if (!confirmLoading) {
      setConfirmOpen(false);
      setConfirmMode(null);
      setTargetOrderId(null);
    }
  }}
/>

 
 
  </>
  );
};

export default Orders;
